import { render, staticRenderFns } from "./AddCourseResource.vue?vue&type=template&id=256d2bfc&scoped=true"
import script from "./AddCourseResource.vue?vue&type=script&lang=js"
export * from "./AddCourseResource.vue?vue&type=script&lang=js"
import style0 from "./AddCourseResource.vue?vue&type=style&index=0&id=256d2bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256d2bfc",
  null
  
)

export default component.exports